import { render, staticRenderFns } from "./SchoolTypeStep.vue?vue&type=template&id=1355a244&scoped=true&"
import script from "./SchoolTypeStep.vue?vue&type=script&lang=js&"
export * from "./SchoolTypeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355a244",
  null
  
)

export default component.exports